
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"300","height":"20","viewBox":"0 0 300 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M299.955 20c-37.835-.139-37.729-6.158-75.557-6.3-37.827-.142-37.947 5.88-75.774 5.738-18.571 0-18.571-2.437-37.15-2.437-18.58 0-18.58 2.437-37.158 2.437-18.58 0-18.58-2.437-37.158-2.437-18.58 0-18.58 2.437-37.158 2.437V0h300l-.045 20z","fill":"currentColor"}})])
          )
        }
      }
    